export const ALERT_VARIANTS = {
  popup: 'popup',
  alert: 'alert',
};

export const OTT_STATUSES = {
  PENDING_CASE_STATUS: 'PENDING',
  ERROR_CASE_STATUS: 'ERROR',
  ABORT_ERROR: 'AbortError',
  CANCELLED: 'ERR_CANCELED',
  FAILURE_ERROR: 'OTT_FAILURE',
};

export const DEFAULT_DATE_PICKER_LOCALE_TEXT = {
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  calendarViewOpen: 'calendar view is open, switch to year view',
  yearViewOpen: 'year view is open, switch to calendar view',
};
